/** @jsx jsx */
import { jsx } from "theme-ui";
import React, { useEffect } from "react";
import { CenterPageLoading } from "components/Loading/Loading";
import Content, { ContentFull } from "components/Content/Content";
import { useAppSelector } from "store/store";
import { isAuthorised } from "store/authorisation";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { withI18n, I18n, withI18nProps } from "@lingui/react";
import { t } from "@lingui/macro";

export interface AuthProps extends withI18nProps {
}

const Auth: React.FC<AuthProps> = ({ i18n }) => {
    const authorised = useAppSelector(isAuthorised);
    const companyId = useAppSelector(s => s.authorisation.entity?.companyId)
    const { addToast, toastStack, removeAllToasts } = useToasts();
    const history = useHistory();

    useEffect(() => {
        const intervalId = setTimeout(() => {
            if (authorised && companyId) {
                history.push(`/${companyId}`)
            } else {
                history.push('/login');
            }

            const message = i18n._(t("Auth.couldNotLogIn")``);
            addToast(message, {
                appearance: "info",
            });
        }, 10000);

        return () => {
            clearInterval(intervalId);
        }

    }, [authorised, companyId])

    return (
        <Content>
            <ContentFull>
                <CenterPageLoading />
            </ContentFull>
        </Content>
    )
}

export default withI18n()(Auth);
